var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMinify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.6C0.9,0.2,1.4,0,1.9,0s1,0.2,1.4,0.6l11.3,11.3V3.7c0-1.1,0.9-2,2-2s2,0.9,2,2v13c0,0.1,0,0.3,0,0.4l0,0 c0,0.1-0.1,0.2-0.1,0.3l0,0c-0.1,0.2-0.2,0.3-0.2,0.4l0,0c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2l0,0 c-0.2,0.1-0.3,0.2-0.4,0.2l0,0c-0.2,0.1-0.3,0.1-0.4,0.2l0,0c-0.1,0-0.3,0-0.4,0h-13c-1.1,0-2-0.9-2-2s0.9-2,2-2h8.2L0.6,3.5 C-0.2,2.7-0.2,1.4,0.5,0.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.3,40.4v-13c0-0.1,0-0.3,0-0.4l0,0c0-0.1,0.1-0.2,0.1-0.3l0,0c0.1-0.1,0.1-0.2,0.2-0.3l0,0c0.1-0.1,0.2-0.2,0.2-0.3 c0.1-0.1,0.2-0.2,0.3-0.2l0,0c0.1-0.1,0.2-0.1,0.3-0.2l0,0c0.1-0.1,0.2-0.1,0.3-0.1l0,0c0.1,0,0.2,0,0.4,0h13.2c1.1,0,2,0.9,2,2 s-0.9,2-2,2h-8.2l11.3,11c0.8,0.8,0.8,2.1,0,2.8c-0.8,0.8-2,0.8-2.8,0L29.3,32.2v8.2c0,1.1-0.9,2-2,2S25.3,41.5,25.3,40.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinify);
export default __webpack_public_path__ + "static/media/icon-minify.d99b0d893af51ed13488932f47f2cfa8.svg";
export { ForwardRef as ReactComponent };